
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M15.787 5.254L8.287.087a.526.526 0 00-.574 0l-7.5 5.167A.503.503 0 000 5.667v9.667C0 15.7.3 16 .667 16h2.666V8.5c0-.275.226-.5.5-.5h8.334c.275 0 .5.225.5.5V16h2.666c.367 0 .667-.3.667-.666V5.667c0-.167-.08-.32-.213-.413z"}}),_c('path',{attrs:{"d":"M4.333 11.666h7.333v1.667H4.333v-1.667zM4.333 14.334h7.333v1.667H4.333v-1.667zM4.333 9h7.333v1.667H4.333V9z"}})])])
          )
        }
      }
    